import { Link } from 'react-router-dom';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
  onReset?: () => void;
}

export default function EmptyState({
  icon = 'ri-inbox-archive-line',
  title,
  description,
  actionLabel,
  actionTo,
  onReset,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300/80 bg-background-100/60 px-6 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-foreground-500">
        <i className={`${icon} text-2xl`} aria-hidden="true"></i>
      </span>
      <h3 className="mt-5 text-base font-medium text-foreground-900">{title}</h3>
      {description && <p className="mt-2 max-w-md text-sm leading-6 text-foreground-500">{description}</p>}
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        {onReset && (
          <button
            type="button"
            onClick={onReset}
            className="whitespace-nowrap rounded-full border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-500/70 hover:text-primary-500"
          >
            重置筛选条件
          </button>
        )}
        {actionLabel && actionTo && (
          <Link
            to={actionTo}
            className="whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            {actionLabel}
          </Link>
        )}
      </div>
    </div>
  );
}